<template>
    <div id="g6-container">
        <div id="mountNode"></div>
    </div>
</template>
<script>
    import G6 from '@antv/g6';
    export default {
        props: {
            list: {
                type: Array,
                default: () => []
            }
        },
        data () {
            return {
                renderData: {
                    nodes: [{id: 'base_001', size: 80, label: '路易'}],
                    edges: []
                },
                renderData_ : {
				    nodes: [
                        { id: 'node0', size: 50 , label: 'node0'},
                        { id: 'node1', size: 30 , label: 'node1'},
                        { id: 'node2', size: 30 , label: 'node2'},
                        { id: 'node3', size: 30 , label: 'node3'},
                        { id: 'node4', size: 30, isLeaf: true, label: 'node4' },
                        { id: 'node5', size: 30, isLeaf: true, label: 'node5'},
                        { id: 'node6', size: 15, isLeaf: true, label: 'node6' },
                        { id: 'node7', size: 15, isLeaf: true, label: 'node7' },
                        { id: 'node8', size: 15, isLeaf: true, label: 'node8' },
                        { id: 'node9', size: 15, isLeaf: true, label: 'node9' },
                        { id: 'node10', size: 15, isLeaf: true, label: 'node10' },
                        { id: 'node11', size: 15, isLeaf: true, label: 'node11' },
                        { id: 'node12', size: 15, isLeaf: true, label: 'node12'  },
                        { id: 'node13', size: 15, isLeaf: true, label: 'node13'  },
                        { id: 'node14', size: 15, isLeaf: true, label: 'node14'  },
                        { id: 'node15', size: 15, isLeaf: true, label: 'node15'  },
                        { id: 'node16', size: 15, isLeaf: true, label: 'node16'  },
                    ],
                    edges: [
                        { source: 'node0', target: 'node1' },
                        { source: 'node0', target: 'node2' },
                        { source: 'node0', target: 'node3' },
                        { source: 'node0', target: 'node4' },
                        { source: 'node0', target: 'node5' },
                        { source: 'node1', target: 'node6' },
                        { source: 'node1', target: 'node7' },
                        { source: 'node2', target: 'node8' },
                        { source: 'node2', target: 'node9' },
                        { source: 'node2', target: 'node10' },
                        { source: 'node2', target: 'node11' },
                        { source: 'node2', target: 'node12' },
                        { source: 'node2', target: 'node13' },
                        { source: 'node3', target: 'node14' },
                        { source: 'node3', target: 'node15' },
                        { source: 'node3', target: 'node16' },
                    ],
                },
                treeData: {},
            }
        },
        mounted () {
            this.treeData = {
                id: 'base_001',
                name: '路易',
                children: []
            }
            let data = JSON.parse(JSON.stringify(this.list))
            console.log('==> data:%O', data)
            this.markRenderTreeData(this.treeData['children'], data)
            console.log('==> this.treeData:%O', this.treeData)
            this.g6renderTree(this.treeData)
        },
        methods: {
            /**
             * 组装绘制的数据
             */
            markRenderTreeData (parent, list) {
                for (let i = 0, len = list.length; i < len; i++) {
                    let item = list[i]
                    // item['style'] = {
                    //     file: 'red'
                    // }
                    item['children'] = item.company || []
                    parent.push(item)
                    if (item.modules) {
                        this.markRenderTreeData(item.children, item.modules)
                    }
                }
            },
            g6renderTree (data) {
                let width = document.getElementById('g6-container').scrollWidth
                const graph = new G6.TreeGraph({
                    container: 'mountNode',
                    width,
                    height: 550,
                    modes: {
                        default: [
                        {
                            type: 'collapse-expand',
                            onChange: function onChange(item, collapsed) {
                                const data = item.get('model');
                                const icon = item.get('group').find(element => element.get('name') === 'collapse-icon');
                                if (collapsed) {
                                    icon.attr('symbol', EXPAND_ICON);
                                } else {
                                    icon.attr('symbol', COLLAPSE_ICON);
                                }
                                data.collapsed = collapsed;
                                return true;
                            },
                        },
                        'drag-canvas',
                        'zoom-canvas',
                        ],
                    },
                    defaultNode: {
                        type: 'tree-node',
                        anchorPoints: [
                            [0, 0.5],
                            [1, 0.5],
                        ],
                    },
                    defaultEdge: {
                        type: 'cubic-horizontal',
                        style: {
                            stroke: '#e8eaec',
                        },
                    },
                    layout: {
                        type: 'mindmap',
                        direction: 'H',
                        getHeight: function getHeight() {
                            return 16;
                        },
                        getWidth: function getWidth() {
                            return 16;
                        },
                        getVGap: function getVGap() {
                            return 10;
                        },
                        getHGap: function getHGap() {
                            return 50;
                        },
                    },
                });
                G6.Util.traverseTree(data, function(item) {
                    item.id = item.name + parseInt(Math.random()*100);
                });
                graph.data(data);
                graph.render();
                graph.fitView();

            }
        }
    }
    const COLLAPSE_ICON = function COLLAPSE_ICON(x, y, r) {
        return [
            ['M', x - r, y - r],
            ['a', r, r, 0, 1, 0, r * 2, 0],
            ['a', r, r, 0, 1, 0, -r * 2, 0],
            ['M', x + 2 - r, y - r],
            ['L', x + r - 2, y - r],
        ];
        };
    const EXPAND_ICON = function EXPAND_ICON(x, y, r) {
        return [
            ['M', x - r, y - r],
            ['a', r, r, 0, 1, 0, r * 2, 0],
            ['a', r, r, 0, 1, 0, -r * 2, 0],
            ['M', x + 2 - r, y - r],
            ['L', x + r - 2, y - r],
            ['M', x, y - 2 * r + 2],
            ['L', x, y - 2],
        ];
        };
    G6.registerNode(
        'tree-node',
        {
            drawShape: function drawShape(cfg, group) {
                // 是否是模块
                let isModule = cfg.children ? true : false
                /**
                    模块配色
                    color: #1890ff
                    background: #e6f7ff;
                    border-color: #91d5ff;
                    公司配色
                    color: #52c41a
                    background: #f6ffed;
                    border-color: #b7eb8f;
                 */
                const rect = group.addShape('rect', {
                    attrs: {
                        fill: isModule ? '#e6f7ff' : '#f6ffed',
                        stroke: isModule ? '#91d5ff' : '#b7eb8f',
                    },
                    name: 'rect-shape',
                });
                // 绘制文本
                const content = cfg.name.replace(/(.{19})/g, '$1\n');
                const text = group.addShape('text', {
                    attrs: {
                        text: content,
                        x: 0,
                        y: 0,
                        textAlign: 'left',
                        textBaseline: 'middle',
                        fill: isModule ? '#1890ff' : '#52c41a',
                    },
                    name: 'rect-shape',
                });
                const bbox = text.getBBox();
                const hasChildren = cfg.children && cfg.children.length > 0;
                // 绘制加减按钮
                if (hasChildren) {
                    group.addShape('marker', {
                        attrs: {
                            x: bbox.maxX + 12,
                            y: bbox.minX + bbox.height / 3,
                            r: 4,
                            symbol: cfg.collapsed ? EXPAND_ICON : COLLAPSE_ICON,
                            stroke: '#91d5ff',
                            lineWidth: 1,
                        },
                        name: 'collapse-icon',
                    });
                }
                rect.attr({
                    x: bbox.minX - 4,
                    y: bbox.minY - 6,
                    width: bbox.width + (hasChildren ? 26 : 8),
                    height: bbox.height + 12,
                });
                return rect;
            },
        },
        'single-node',
    );
</script>



// WEBPACK FOOTER //
// ../projectCore/src/components/drag-list/src/look.vue